import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchNextSteps } from '../../store/nextSteps/nextSteps.reducer'
import { selectNextSteps } from '../../store/nextSteps/nextSteps.selectors'

import { selectIsOffline } from '~/agent/store/agent.selectors'
import { selectIsPostpaid } from '~/sale/store/sale.selectors'

export default function useNextStepsTexts() {
  const dispatch = useDispatch()

  const nextStepsTexts = useSelector(selectNextSteps)
  const isPostpaid = useSelector(selectIsPostpaid)
  const isOffline = useSelector(selectIsOffline)

  useEffect(() => {
    dispatch(fetchNextSteps({ isPostpaid, isOffline }))
  }, [])

  return { nextStepsTexts }
}
